module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEcSURBVHgB1VRtDcIwEH0k/AYDmwEwAA4QABgADAwFKGD/IQgYE0AQQJgAMgGAAKaAXtbB0X20ZeMHL3lJ29291/auA77DQjAWXOIHINE7Y6MmXHzXtAkXn8s1rykTLj5RvtU2WVWI1zbxZRJ1TF8TGzKTxsV95OtTio7gUQafNeIUG7KNDGEp7lTEuoKR4UZeCabifUXcgYG4aQJdQyxj90hPrYWp+ALvYq5hgSypSpw/Ng+W0PWvVRvaGFi3oYq2MqcrusmxK8Vp7So4E7ywWKpHT8l/CCZsHqgGEfIg8TEzzjAQHKEaTksOqCOGbOcZTkh3nhQku8hfWQefbRvg79Fi4yn0T56O34U5ttzA+D9ugY3tCRIUF7wMhyfmXGEa/BghmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/test/edit_test_icon.png
// module id = ZuUy
// module chunks = 4